/* @flow */

import React from 'react';
import { Img } from 'glamorous';

type Props = {
  alt?: string,
  height?: string,
  images: Array<string>,
  maxWidth?: string,
};

const defaultProps = {
  alt: '',
  height: 'auto',
  maxWidth: '100%',
};

function ResponsiveImage({
  alt,
  height,
  images,
  maxWidth,
  ...rest
}: Props) {
  return (
    <Img
      {...rest}
      alt={alt}
      height={height}
      maxWidth={maxWidth}
      src={images[0]}
      srcSet={images.map((value, i) => `${value} ${i + 1}x`).join(', ')}
    />
  );
}

ResponsiveImage.defaultProps = defaultProps;

export default ResponsiveImage;
